import { render, staticRenderFns } from "./welcome-card.vue?vue&type=template&id=26684f66&scoped=true&"
import script from "./welcome-card.vue?vue&type=script&lang=js&"
export * from "./welcome-card.vue?vue&type=script&lang=js&"
import style0 from "./welcome-card.vue?vue&type=style&index=0&id=26684f66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26684f66",
  null
  
)

export default component.exports